import ArticleContextProvider, { useArticleContext } from './CreditFlowArticleContext';

export { useArticleContext };
export default ArticleContextProvider;
